import { Message } from 'element-ui'
import nexus from '@db2b/nexus-js'
import { events } from './event-bus'

export default {
  /*
   * EVENT HANDLING
   */
  on (name, callback) {
    events.on('app/' + this.getName() + '/' + name, callback)
  },

  fire (name, options) {
    events.emit('app/' + this.getName() + '/' + name, options)
  },

  /*
   * CRUD ACTIONS HANDLING
   */
  create ({item, options}) {
    events.emit('app/' + this.getName() + '/create', {item, options})
  },

  edit ({item, options}) {
    events.emit('app/' + this.getName() + '/edit', {item, options})
  },

  delete ({item, options}) {
    events.emit('app/' + this.getName() + '/delete', {item, options})
  },

  /*
   * API CALLS
   */
  api () {
    let self = this

    return {
      create (attributes) {
        return nexus.axios.post(self.getUrl(), attributes)
          .then((response) => {
            Message.success({
              message: 'Création de l\'élément "' + self.options.translations.name + '" effectué avec succès.',
            })
          }).catch((err) => {
            Message.error({
              message: 'Erreur lors de la création de l\'élément "' + self.options.translations.name + '".',
              duration: 0,
              showClose: true
            })
          })
      },

      update (id, attributes) {
        return nexus.axios.put(self.getUrl(id), attributes)
          .then((response) => {
            Message.success({
              message: 'Modification de l\'élément "' + self.options.translations.name + '" n°' + id + ' effectué avec succès.',
            })
          }).catch((err) => {
            Message.error({
              message: 'Erreur lors de la modification de l\'élément "' + self.options.translations.name + ' n°' + id + '".',
              duration: 0,
              showClose: true
            })
          })
      },

      delete (id) {
        return nexus.axios.delete(self.getUrl(id))
          .then(() => {
            Message.success({
              message: 'Suppression de l\'élément "' + self.options.translations.name + '" n°' + id + ' effectué avec succès.',
            })
          }).catch((err) => {
            Message.error({
              message: 'Erreur lors de la suppression de l\'élément "' + self.options.translations.name + ' n°' + id + '".',
              duration: 0,
              showClose: true
            })
          })
      }
    }
  },

  /*
   * HELPERS
   */
  getUrl (path) {
    if (path) {
      return this.options.url + '/' + path
    } else {
      return this.options.url
    }
  },

  getName () {
    return this.options.name.replace(new RegExp('-', 'g'), '_')
  },

  get : function() {
    this.api.parent = this;
    delete this.init;
    return this;
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/utils/model.js